/**
 * @name isSafari
 *
 * @description Function returns true when browser is Safari
 *
 * @example
 * import { isSafari } from '@workbench/core';
 *
 * if (isSafari()) {
 *   // run Safari fallback...
 * }
 */
export function isSafari(): boolean {
  return navigator.userAgent.indexOf('Safari') && navigator.userAgent.indexOf('Chrom') === -1; // note: checks for Chromium and Chrome
}
